import type { FormEvent, ReactNode } from 'react';
import cn from 'classnames';
import styles from './SearchPanelWrapper.module.css';

interface SearchPanelWrapperProps {
    onSubmit: (event: FormEvent<HTMLFormElement>) => void;
    action?: string;
    method?: 'GET' | 'POST';
    className?: string;
    dataTestId?: string;
    children: ReactNode;
}

export const SearchPanelWrapper = ({ onSubmit, action, method, className, children, dataTestId }: SearchPanelWrapperProps) => (
    <form
        autoComplete="off"
        onSubmit={onSubmit}
        className={cn(styles.form, className)}
        action={action}
        method={method}
        data-testid={dataTestId}>
        {children}
    </form>
);
